/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-promise-executor-return */

import { AFCuid, AFEvent } from 'appsflyer-capacitor-plugin';

import { APPS_FLYER_URL, MAX_LOAD_ATTEMPTS, LOAD_ATTEMPT_TIMEOUT_MS } from './appsflyer.constants';
import { AppsFlyerApi } from './appsflyer.types';

export class AppsFlyerWebSDK {
  static async getSdk(webDevKey: string): Promise<AppsFlyerApi | null> {
    // If script is already loaded, create SDK instance directly
    if (window.AF && typeof window.AF === 'function') {
      await this.waitForPba();
      return this.createSDKInstance();
    }

    // Load script and create SDK instance
    return this.loadScript(webDevKey);
  }

  private static async waitForPba(): Promise<void> {
    // Limit attempts to avoid infinite loop if PBA never loads
    for (let attempt = 1; attempt <= MAX_LOAD_ATTEMPTS; attempt++) {
      if (window.AF_SDK?.PLUGINS?.PBA) return;
      await new Promise((r) => setTimeout(r, LOAD_ATTEMPT_TIMEOUT_MS));
    }

    // eslint-disable-next-line no-console
    console.error('AppsFlyer PBA plugin failed to load within the allowed time');
  }

  private static createSDKInstance(): AppsFlyerApi | null {
    if (window.AF) {
      const AppsFlyer = window.AF;

      return {
        logEvent: (eventData: AFEvent) => AppsFlyer('pba', 'event', { eventType: 'EVENT', ...eventData }),
        setCustomerUserId: (cuid: AFCuid) => AppsFlyer('pba', 'setCustomerUserId', cuid),
      };
    }

    return null;
  }

  private static loadScript(devKey: string): Promise<AppsFlyerApi | null> {
    return new Promise<AppsFlyerApi | null>((resolve, reject) => {
      // Official AppsFlyer Web SDK snippet
      // eslint-disable-next-line @typescript-eslint/no-explicit-any,func-names
      (function (t: any, e: any, n: any, s: any, a: any, c: any, i: any, o: any, p: any) {
        t.AppsFlyerSdkObject = a;
        t[a] =
          t[a] ||
          // eslint-disable-next-line @typescript-eslint/no-explicit-any,func-names
          function (...args: any[]) {
            (t[a].q = t[a].q || []).push([Date.now()].concat(args));
          };
        t[a].id = t[a].id || i;
        t[a].plugins = {};
        o = e.createElement(n);
        p = e.getElementsByTagName(n)[0];
        o.async = 1;
        o.src = `${APPS_FLYER_URL}?${c.length > 0 ? `st=${c.split(',').sort().join(',')}&` : ''}${
          i.length > 0 ? `af_id=${i}` : ''
        }`;

        o.onload = async () => {
          try {
            await AppsFlyerWebSDK.waitForPba();
            resolve(AppsFlyerWebSDK.createSDKInstance());
          } catch (err) {
            reject(err);
          }
        };

        o.onerror = () => {
          reject(new Error('Failed to load AppsFlyer Web SDK script'));
        };

        if (p && p.parentNode) {
          p.parentNode.insertBefore(o, p);
        }
      })(window, document, 'script', 0, 'AF', 'pba', devKey, null, null);
    });
  }
}
